import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConvenioComponent } from './convenio.component';



@NgModule({
  declarations: [
    ConvenioComponent
  ],
  imports: [
    CommonModule
  ], exports:[
    ConvenioComponent
  ]
})
export class ConvenioModule { }
